module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/inspiration-elite-toolbar.e6f58048.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/inspiration-elite-toolbar.png
// module id = 3720
// module chunks = 11